import React from "react";
import { Loader2 } from "lucide-react";

// Horizontale voortgangsbalk met optionele fase-labels, getoond tijdens het laden.
// pct weglaten (null/undefined) => indeterminate (animerend) balkje voor eenmalige loads.
export const LaadBalk = ({ pct, fasen, label = "Laden" }) => {
  const indeterminate = pct == null;
  return (
    <div className="space-y-1.5" data-testid="laadbalk">
      <div className="flex justify-between text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" /> {label}…{indeterminate ? "" : ` (${pct}%)`}
        </span>
        {fasen && (
          <span className="hidden sm:inline">
            {fasen.map((f) => `${f.label} ${f.done ? "\u2713" : "\u2026"}`).join(" \u00b7 ")}
          </span>
        )}
      </div>
      <div className="h-1.5 w-full bg-secondary rounded-full overflow-hidden">
        {indeterminate ? (
          <div className="h-full w-1/3 bg-primary rounded-full animate-pulse" style={{ marginLeft: "auto", marginRight: "auto" }} />
        ) : (
          <div
            className="h-full bg-primary transition-all duration-500 ease-out rounded-full"
            style={{ width: `${pct}%` }}
            data-testid="laadbalk-fill"
          />
        )}
      </div>
    </div>
  );
};

// Tabelrij: toont een spinner + pulserende balk tijdens het laden, anders de lege-melding.
export const TabelLaadRij = ({ colSpan, loading, leeg = "Geen resultaten." }) => (
  <tr>
    <td colSpan={colSpan} className="p-10">
      {loading ? (
        <div className="flex flex-col items-center gap-3 text-muted-foreground" data-testid="tabel-laden">
          <Loader2 className="h-6 w-6 animate-spin text-primary" />
          <span className="text-sm">Laden…</span>
          <div className="h-1.5 w-56 bg-secondary rounded-full overflow-hidden">
            <div className="h-full w-full bg-primary/60 rounded-full animate-pulse" />
          </div>
        </div>
      ) : (
        <div className="text-center text-muted-foreground">{leeg}</div>
      )}
    </td>
  </tr>
);
